import HeroSection from './HeroSection';
import Margin from '@/components/comm/Margin';
import useCustomBreakpoint from '@/components/pages/about/comm/lib/custom-breakpoint.service';
import ApplySection from '@/components/pages/about/main/ApplySection';
import CertiDetailSection from '@/components/pages/about/main/CertiDetailSection';
import IntroSection from '@/components/pages/about/main/IntroSection';
import OutroSection from '@/components/pages/about/main/OutroSection';
import PartnerSection from '@/components/pages/about/main/PartnerSection';
import SkillupSection from '@/components/pages/about/main/SkillupSection';

const pageTitle = '시험 소개';

const AboutMain: NextPageWithAppProps = () => {
  return (
    <>
      <HeroSection />
      <MarginBottomForHeroSection />
      <ApplySection />
      <IntroSection />
      <PartnerSection />
      <CertiDetailSection />
      <SkillupSection />
      <OutroSection />
      <BottomSpacer />
    </>
  );
};

const marginMap = {
  sm: '40px',
  mdSmall: '40px',
  md: '56px',
  lg: '80px',
};

const MarginBottomForHeroSection = () => {
  const breakpoint = useCustomBreakpoint();

  return <Margin vertical={marginMap[breakpoint]} />;
};

const BottomSpacer = () => {
  return <div style={{ height: '41px' }} />;
};

AboutMain.getLayoutProps = () => ({
  withoutFooterTopMargin: true,
});

export default AboutMain;

AboutMain.getPageProps = () => ({
  pageTitle,
});
